import { WEB_COMPONENT_GZ_LANDING_PAGE_APP } from '../webcomponents.constants';
import { GzLandingPageAppWebComponent } from './component/GzLandingPageAppWebComponent';

export { GzLandingPageAppWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_LANDING_PAGE_APP, GzLandingPageAppWebComponent);
